import { isOptinChecked, preventPostalCodeMaxLength } from "@/services/validations.js";
import { required, email, helpers} from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import EventBus from "@/event-bus";

const phone = helpers.regex("phone", /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/);
const postalCode = helpers.regex("postalCode", /^(?:[0-9]\d|9[0-8])\d{3}$/);
const forbiddenCityValues = ["city"];
const forbiddenAdressValues = ["street address"];

const forbiddenCityValue = helpers.withParams(
  { type: "forbiddenCityValue" },
  value => {
    if (!value) return true;
    return !forbiddenCityValues.includes(value.trim().toLowerCase());
  }
);

const forbiddenAdressValue = helpers.withParams(
  { type: "forbiddenAdressValue" },
  value => {
    if (!value) return true;
    return !forbiddenAdressValues.includes(value.trim().toLowerCase());
  }
);

export default {
    
    /*-------------------------
        Datas
    ---------------------------*/
    data() {
        return {
            accountExistCheck: false,
            asBeenFilled: false,
            formName: "",
            
            requiredInfos: {
                formName: "",
                dispatchTarget: "",
                dispatchFillPercent: "",
                requiredDatas: {},
            },
            formValidations: {
                // WizzardInfos
                prefix: "",
                firstname: "",
                lastname: "",
                email: "",
                isPro: "no",
                phone: "",
                adresse: "",
                postalcode: "",
                city: "",
                country: "France",
                comment: "",
                company: "",
                createAccount: false,
                commentInfo: false,
                proxiserve_optin: false,
    
                // Checkout
                floor: "",
                elevator: "",
                company: "",
                addressComplement: "",
                billingFirstname: "",
                billingLastname: "",
                billingPhone: "",
                billingAdresse: "",
                billingAddressComplement: "",
                billingPostalcode: "",
                billingCity: "",
                billingCountry: "France",
                shippingAsBilling: true,

                // Login
                emailLogin: "",
                password: "",
            }
        };
    },

    /*-------------------------
        Computed
    ---------------------------*/
    computed: {
        ...mapGetters({cartDelivery: "getCurrentCartDelivery"}),
    },

    validations: {
        formValidations: {
            email: {
                required,
                email,
            },
            prefix: {
                required,
            },
            firstname: {
                required,
            },
            lastname: {
                required,
            },
            isPro: {
                required,
            },
            company: {
                required,
            },
            adresse: {
                required,
                forbiddenAdressValue,
            },
            postalcode: {
                required,
                postalCode,
            },
            city: {
                required,
                forbiddenCityValue,
            },
            country: {
                required,
            },
            phone: {
                required,
                phone,
            },
            /* proxiserve_optin: {
                isOptinChecked,
                required,
            }, */

            //Billing
            billingFirstname: {
                required,
            },
            billingLastname: {
                required,
            },
            billingCompany: {
                required,
            },
            billingAdresse: {
                required,
            },
            billingPostalcode: {
                required,
                postalCode,
            },
            billingCity: {
                required,
            },
            billingCountry: {
                required,
            },
            billingPhone: {
                required,
                phone,
            },

            // Login
            emailLogin: {
                required,
                email,
            },
            password: {
                required,
            },
        },
    },

    /* -------------------------
        Methods
    --------------------------- */
    methods: {
        /**
         * set formName
         * need to set to form => ref="formName" data-name="<nameOfForm" 
         */
        handleRequiredInfos() {
            if(this.$refs.formName) {
                const formName = this.$refs.formName.dataset.name;
                this.formName = formName;

                this.requiredInfos.formName = formName;

                switch (formName) {
                    case "checkout":
                        this.requiredInfos.dispatchTarget = "setCheckoutInfoDataRequired";
                        this.requiredInfos.requiredDatas = this.checkoutInfo;
                        this.requiredInfos.dispatchFillPercent = "setCheckoutFillPercent";
                        break;
                    case "wizard":
                        this.requiredInfos.dispatchTarget = "setWizardInfoDataRequired";
                        this.requiredInfos.requiredDatas = this.wizardInfo;
                        this.requiredInfos.dispatchFillPercent = "setWizardFillPercent";
                        break;
                    default:
                        break;
                }
            } 
        },

        /**
         * 
         * @param {Event} event 
         * @returns 
         */
        checkEmailValidity(event) {
            const re =
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(String(event.target.value).toLowerCase())) return;
            this.$v.formValidations.email.$touch();
        },

        /**
         * 
         * @param {String} name 
         */
        displayMissingRequired(name) {
            const requiredInput = document.querySelectorAll("[required]");
            
            for (let i = 0; i < requiredInput.length - 1; i++) {
              if (this.$v.formValidations[requiredInput[i].name]) {
                this.$v.formValidations[requiredInput[i].name].$touch();
              }
              if (requiredInput[i].name === name) {
                break;
              }
            }
        },

        /**
         * display all errors missing required fields
         */
        displayAllMissingRequired() {
            let requiredInput = document.querySelectorAll("[required]");
            
            for (let i = 0; i < requiredInput.length; i++) {
              if (!this.$v.formValidations[requiredInput[i].name]) continue;
              
              this.$v.formValidations[requiredInput[i].name].$touch();
              this.setDataRequiredOnTarget(requiredInput[i].name);
            }
        },

        /**
         * handle form Fill progress
         * @param {Object} formFields 
         */
        formFillProgress(formFields) {
            let fieldNumber = 0;
            let remain = 0;
            let shippingAsBilling = this.formValidations?.shippingAsBilling;
            const fields = formFields;
            
            Object.entries(fields).forEach(key => {
                const isSameAsBilling = shippingAsBilling && shippingAsBilling === true && key[0].indexOf("billing") !== -1;
                /* const isOptinKey = key[0] === "proxiserve_optin"; 
                const isOptinChecked = isOptinKey  && key[1] === true*/
              
                if (isSameAsBilling || key[0] === "shippingAsBilling") return;

                fieldNumber++;
                key[1] === "" ? remain++ : false;
            });

            if(this.isZeborne && this.cartDelivery.type == 'renting') {
              Object.entries(this.checkoutInfoRenting).forEach(key => {
                fieldNumber++;
                key[1] === "" ? remain++ : false;
              });
            }
      
            if(this.accountExist && this.isCurrentUserIsLoggedIn === false) remain++;
                        
            this.$store.dispatch(this.requiredInfos.dispatchFillPercent, 100 - (remain * 100) / fieldNumber);
        },

        /**
         * 
         * @param {Array} inputs 
         * @returns 
         */
        checkFormValidity(inputs) {
            let isFormValid = true
            
            inputs.forEach(input => {
                if(!this.formValidations[input] || this.formValidations[input] && this.formValidations[input].$invalid) {
                    isFormValid = false
                }
            })

            return isFormValid;
        },

        /**
         * setDataRequired
         * @param {String} name 
         * @returns 
         */
        setDataRequired(name) {
            if(typeof name !== "string") return;
            this.setDataRequiredOnTarget(name);
        },

        /**
         * set required info in store
         * @param {String} name 
         */
        async setDataRequiredOnTarget(name) {
            if (this.$v.formValidations[name] && !this.$v.formValidations[name].$invalid) {
                this.$store.dispatch(this.requiredInfos.dispatchTarget, {
                    data: this.formValidations[name],
                    type: name,
                });
                if (name === "email") {
                    this.accountExistCheck = await this.verifyAccountByEmail(this.formValidations[name]);
                }
            } else if (name === "postalcode") {
                this.$store.dispatch(this.requiredInfos.dispatchTarget, {
                  data: this.formValidations[name],
                  type: name,
                }); 
            } else if(this.$v.formValidations[name] && this.$v.formValidations[name].$invalid){
                this.$store.dispatch(this.requiredInfos.dispatchTarget, {
                    data: "",
                    type: name,
                });
            }
    
            this.formFillProgress(this.requiredInfos.requiredDatas);
            this.displayMissingRequired(name);
           
        },

        /**
         * auto fill value if user is logged In
         * @param {Boolean} checkValidation - default false
         * @returns 
         */
        fillInputWithValue(checkValidation=false) {

            if (!this.isCurrentUserIsLoggedIn) return;
            
            let userInfo = Object.values(this.currentUserInfo);
            let userShippingInfo = Object.values(this.currentUserShippingInfo);
            let neededStoreKeys = Object.keys(this.requiredInfos.requiredDatas);
            let formData = this.formValidations;
      
            // SET USER DATA
            Object.keys(this.currentUserInfo).forEach((value, index) => {  
                if (document.getElementById(value.toLowerCase())) {
                    document.getElementById(value.toLowerCase()).value = userInfo[index];
                }

                formData[value.toLowerCase()] = userInfo[index];
                
                if (neededStoreKeys.includes(value.toLowerCase())) {
                    this.setDataRequired(value.toLowerCase());
                }

                // Validation input
                if(checkValidation && this.$v.formValidations[value.toLowerCase()]) this.$v.formValidations[value.toLowerCase()].$touch(); 
                
            });
      
            // SET SHIPPING ADRESS DATA
            Object.keys(this.currentUserShippingInfo).forEach((value, index) => {
                    if(this.requiredInfos.formName && this.requiredInfos.formName == "checkout" && value == "postalcode") return; // no override of postalcode on checkoutpage because already selected via mcp_intervention_zipcode
                    
                    if (document.getElementById(value.toLowerCase())) {
                        document.getElementById(value.toLowerCase()).value = userShippingInfo[index];
                    }

                    formData[value.toLowerCase()] = userShippingInfo[index];
                    
                    if (neededStoreKeys.includes(value.toLowerCase())) {
                        this.setDataRequired(value.toLowerCase());
                    }
                    
                    // Validation input
                    if(checkValidation && this.$v.formValidations[value.toLowerCase()]) this.$v.formValidations[value.toLowerCase()].$touch(); 
                },
            );
      
            this.asBeenFilled = true;
            this.displayAllMissingRequired();
        },

        handleError(errorMessage, err) {
            console.error(errorMessage);
            console.log(err);
        },

        isOptin(value) {  
            switch (this.formName) {
                case "checkout":
                    this.setOptinData(value);
                    break;
                case "wizard":
                    this.setWizardOptinData(value);
                    break;
            
                default:
                    this.setWizardOptinData(value);
                    break;
            }
            this.formValidations.proxiserve_optin = value;
        },

        /**
         * Map Actions
         */
        ...mapActions(["setOptinData", "setWizardOptinData"])
    },

    /*-------------------------
        Mounted
    ---------------------------*/
    mounted() {
        this.handleRequiredInfos();
    },
    

    /*-------------------------
        Watch
    ---------------------------*/
    watch: {
        'formValidations.proxiserve_optin': function (newVal) {
            if (newVal) {
                this.isOptin(newVal);
            }
        }
    },
};
